module.exports = __webpack_public_path__ + "static/Inspiration-d5ee06528f18f270a80a750c6cff53e3.svg";